module.exports = __webpack_public_path__ + "img/icon-4.c74e439a.svg";